import * as React from "react";
import styled from "styled-components";
import { Panel, Input } from "components/bootstrap";
import Select from "components/common/Select";
import { naturalSortIgnoreCase } from "util/SortUtils";
import Spinner from "components/common/Spinner";
const StyledInlineCode = styled("code")`
  margin: 0 0.25em;
  white-space: nowrap;
`;
const LookupTableParameterEdit = ({
  validationState = {},
  onChange,
  lookupTables,
  identifier,
  parameter = {},
  defaultExpandHelp = true
}) => {
  var _a, _b, _c, _d, _e;
  const { lookupTable, key: tableKey, defaultValue, name } = parameter;
  const parameterSyntax = `$${name}$`;
  const _handleChange = (fieldName) => (value) => {
    onChange(fieldName, value);
  };
  const _handleInputChange = (attributeName) => ({ target: { value } }) => _handleChange(attributeName)(value);
  if (!lookupTables) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading lookup tables" });
  }
  const lookupTableOptions = lookupTables.sort((lt1, lt2) => naturalSortIgnoreCase(lt1.title, lt2.title)).map((table) => ({ label: table.title, value: table.name }));
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `lookup-table-parameter-table-${identifier}`,
      name: "query-param-table-name",
      label: "Lookup Table",
      bsStyle: (_a = validationState == null ? void 0 : validationState.lookupTable) == null ? void 0 : _a[0],
      error: (_b = validationState == null ? void 0 : validationState.lookupTable) == null ? void 0 : _b[1],
      help: "Select the lookup table to use for retrieving the values."
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: "Select lookup table",
        onChange: _handleChange("lookupTable"),
        options: lookupTableOptions,
        value: lookupTable,
        autoFocus: true,
        clearable: false,
        required: true
      }
    )
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: `lookup-table-parameter-key-${identifier}`,
      label: "Lookup Table Key",
      name: "key",
      defaultValue: tableKey,
      onChange: _handleInputChange("key"),
      bsStyle: (_c = validationState == null ? void 0 : validationState.key) == null ? void 0 : _c[0],
      help: "Select the lookup table key",
      error: ((_d = validationState == null ? void 0 : validationState.key) == null ? void 0 : _d[0]) === "error" ? (_e = validationState == null ? void 0 : validationState.key) == null ? void 0 : _e[1] : void 0,
      spellCheck: false,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `lookup-table-parameter-default-value-${identifier}`,
      type: "text",
      name: "defaultValue",
      label: "Default Value",
      help: "Select a default value in case the lookup result is empty",
      defaultValue,
      spellCheck: false,
      onChange: _handleInputChange("defaultValue")
    }
  ), /* @__PURE__ */ React.createElement(Panel, { id: "lookup-table-parameter-help", defaultExpanded: defaultExpandHelp }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, { toggle: true }, "How to use lookup table parameters")), /* @__PURE__ */ React.createElement(Panel.Collapse, null, /* @__PURE__ */ React.createElement(Panel.Body, null, /* @__PURE__ */ React.createElement("h5", null, "General Usage"), /* @__PURE__ */ React.createElement("p", null, "After declaring it, the parameter", /* @__PURE__ */ React.createElement(StyledInlineCode, null, parameterSyntax), "in your query, will be replaced with the list of results from the lookup table. The list of results will be presented in the form of a Lucene BooleanQuery. E.g.:", /* @__PURE__ */ React.createElement(StyledInlineCode, null, '("foo" OR "bar" OR "baz")')), /* @__PURE__ */ React.createElement("h5", null, "Behaviour on empty lookup result list"), /* @__PURE__ */ React.createElement("p", null, "The event definition query is only executed if a value for the parameter is present. If the lookup result is empty, the execution will be skipped and treated as if the ", /* @__PURE__ */ React.createElement("i", null, "Search Query"), " found no messages. If an execution is desired a ", /* @__PURE__ */ React.createElement("i", null, "Default Value"), " that yields the desired search result needs to be provided. For example, (depending on the use case) a wildcard like", /* @__PURE__ */ React.createElement(StyledInlineCode, null, "*"), "can be a meaningful Default Value."), /* @__PURE__ */ React.createElement("h5", null, "Limitations"), /* @__PURE__ */ React.createElement("p", null, "Please note, the maximum number of supported results is depending on the", /* @__PURE__ */ React.createElement(StyledInlineCode, null, "opensearch_indices_query_bool_max_clause_count"), " setting. If the lookup table returns more results, the query will fail in your indexer.")))));
};
export default LookupTableParameterEdit;
